import React, {FC} from 'react';

import {useHasBeenOnScreen} from '../../state/hooks';
import {PanelCompRedux} from '../../util/panels';
import {EditablePanel} from './EditablePanel';
import {EditablePanelFullScreenWrapper} from './EditablePanelFullScreenWrapper';
import {usePanelContext} from './PanelContextProvider';
import {PanelProps} from './types';

const wrapperStyles = {
  height: '100%',
  width: '100%',
};

export const EmptyPanelContainer = () => {
  return <div className="h-full w-full border border-moon-300 bg-white" />;
};

export const Panel: FC<PanelProps> = props => {
  const {ref: domRef, hasBeenOnScreen} = useHasBeenOnScreen();
  const {isReadOnly, panelRef} = usePanelContext();
  if (props.mode === 'embedded') {
    return (
      <PanelCompRedux
        configMode={false}
        currentHeight={props.currentHeight}
        dimensions={undefined as any}
        disableRunLinks={props.disableRunLinks}
        onContentHeightChange={props.onContentHeightChange}
        panelRef={panelRef}
        readOnly={isReadOnly}
      />
    );
  }

  if (props.mode === 'full-screen-workspace') {
    return <EditablePanelFullScreenWrapper {...props} />;
  }

  return (
    <div ref={domRef} style={wrapperStyles}>
      {hasBeenOnScreen ? <EditablePanel {...props} /> : <EmptyPanelContainer />}
    </div>
  );
};
